let gaReady = false;

export const initGA = (measurementId) => {
  const cleaned = String(measurementId || "").trim();
  if (gaReady || !cleaned || typeof window === "undefined") return;
  const id = cleaned.startsWith("G-") ? cleaned : `G-${cleaned}`;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", id, { send_page_view: false });
  gaReady = true;
  gaPageView(window.location.pathname, document.title);
};

export const gaEvent = (name, params = {}) => {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
};

export const gaPageView = (path, title) => {
  gaEvent("page_view", {
    page_title: title,
    page_location: window.location.href,
    page_path: path,
  });
};
